module.exports = __webpack_public_path__ + "static/media/mmR.8ab0bc6e.png";